<template>
  <div class="row">
    <div class="col-12">
      <card-filter
        @setupTable="setupTable"
        @filter="handleFilter"
        @showHideLoading="showHideLoading"
      />
      <card :title="tableName" v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :objectSpanMethod="objectSpanMethod"
            :cellStyle="handleCellStyle"
            :infoTable="queriedData"
            :columns="tableColumns"
            :defaultSort="{ prop: 'worker_code', order: 'ascending' }"
            :showColumnStatus="false"
          />
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDFHeader(tableData, tableName, rowspanInfo)"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLSHeader(tableData, tableName, rowspanInfo)"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
            <div class="px-3">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                style="
                  background-color: #0079c1 !important;
                  border-color: #0079c1 !important;
                "
                @click="exportTransportBonusToSAP()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_sap') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
      <card :title="tableName2" v-if="tableData2.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination2"
            @searchedQuery="searchedQueryTable2"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :objectSpanMethod="objectSpanMethod2"
            :cellStyle="handleCellStyle"
            :infoTable="queriedData2"
            :columns="tableColumns2"
            :defaultSort="{ prop: 'worker_code', order: 'ascending' }"
            :showColumnStatus="false"
          />
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter2" :propPagination="pagination2" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDFHeader(tableData2, tableName2, rowspanInfo2)"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLSHeader(tableData2, tableName2, rowspanInfo2)"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
            <div class="px-3">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                style="
                  background-color: #0079c1 !important;
                  border-color: #0079c1 !important;
                "
                @click="exportRoomBonusToSAP()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_sap') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import CardFilter from './CardFilter.vue';
import configTable from './wayuu-community-bonus-table';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import MixinExportWayuuReport from './mixin-export-wayuu-community-bonus';
import MixinGroupData from './mixin-group-data';

export default {
  components: {
    [CardFilter.name]: CardFilter,
    LPagination,
  },
  data() {
    return {
      dataFilter: {},
      model: null,
      tableColumns: [],
      fuseSearch2: null,
      pagination2: {},
      searchedQuery2: '',
      tableColumns2: [],
      tableData2: [],
      tableName: '',
      tableName2: '',
      rowspanInfo2: {},
      rowSpanPagination2: {},
      tableSpanInfoNumber: 1,
    };
  },
  mixins: [
    MixinMasters,
    MixinMenu,
    MixinPermissions,
    MixinExportWayuuReport,
    MixinGroupData,
  ],
  watch: {
    '$i18n.locale': ['setupTable'],
  },
  computed: {
    ...configTable().Search2,
    getDataToExportTransport() {
      const response = {
        data: { ...this.tableData },
      };
      delete response.route;

      return response;
    },
    getDataToExportBonus() {
      const response = {
        data: { ...this.tableData2 },
      };
      delete response.route;

      return response;
    },
    calculateSpanPagination() {
      return this.preprocessDataPagination(
        this.queriedData,
        ['worker_name', 'farm_name', 'fortnight_name'],
        'rowSpanPagination'
      );
    },
    calculateSpanPagination2() {
      return this.preprocessDataPagination(
        this.queriedData2,
        ['worker_name', 'farm_name', 'fortnight_name'],
        'rowSpanPagination2'
      );
    },
  },
  methods: {
    searchedQueryTable2(searchedValue) {
      this.searchedQuery2 = searchedValue;
    },
    objectSpanMethod2({ rowIndex, columnIndex }) {
      this.calculateSpanPagination2;
      if (columnIndex <= this.numberColumnIndex) {
        if (this.rowSpanPagination2[rowIndex]) {
          const span = Math.min(
            this.rowSpanPagination2[rowIndex],
            this.pagination2.perPage - rowIndex
          );

          return {
            rowspan: span,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    handleCellStyle({ row }) {
      if (
        Number(row.days) > Number(row.payment_limit) ||
        Number(row.days) === 0
      ) {
        return 'background-color: #fde6e4;';
      }

      return '';
    },
    handleFilter(data) {
      const moduleUrl = sessionStorage.getItem('urlModule');
      const modules = JSON.parse(sessionStorage.getItem('levelThree'));
      const moduleFind = modules.find(
        ({ url }) => `/${url}` === (moduleUrl ? moduleUrl : '')
      );

      this.dataFilter = {
        ...this.dataFilter,
        ...data,
        module_id: moduleFind ? moduleFind.id : 1,
      };
      this.getDataSamples();
    },
    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/wayuucommunitybonus';
      Axios.postMasters(data)
        .then((response) => {
          const dataResponse = response.data.data;
          if (dataResponse.length == 0) {
            SweetAlert.warning(i18n.t('sweet_alert.jobs.unavailable_data'));
          } else {
            this.numberColumnIndex = 5;
            this.tableData = this.preprocessData(dataResponse[0].rows, [
              'worker_name',
              'farm_name',
              'fortnight_name',
            ]);
            this.tableName = dataResponse[0].bonus_name;
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 50;
            this.pagination.currentPage = 1;

            try {
              this.tableData2 = this.preprocessData(
                dataResponse[1].rows,
                ['worker_name', 'farm_name', 'fortnight_name'],
                2
              );
              this.tableName2 = dataResponse[1].bonus_name;
              this.fuseSearch2 = new Fuse(this.tableData2, {
                useExtendedSearch: true,
                threshold: 0.3,
                keys: this.tableColumns2.map((prop) => {
                  return prop.prop;
                }),
              });

              this.pagination2.perPage = 50;
              this.pagination2.currentPage = 1;
              this.searchedQuery2 = '';
            } catch (error) {
              this.tableData2 = [];
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Table2 } = configTable();
      this.pagination = { ...Table.pagination };
      this.pagination2 = { ...Table2.pagination };
      this.tableColumns = Table.tableColumns;
      this.tableColumns2 = Table2.tableColumns;
      this.pagination.perPage = 5;
      this.pagination.currentPage = 1;
      this.pagination2.perPage = 5;
      this.pagination2.currentPage = 1;
    },
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
